import ValidationErrorService from '../services/ValidationErrorService'
import fileReader from "./fileReader";
import linq from 'linq'

export default {

    data() {
        return {
        }
    },

    methods: {
        /**
         *
         * @param e Error
         * 500, 422対応
         */
        $errorModal(e, message='技術的な問題が発生しています。\n処理を中断しました。', call = value => {}) {
            const status = this.getStatus(e)

            if(!status) {
                this.serverError(message, call())
            }

            if(status === 500) {
                this.$notify({
                    title: message,
                    type: 'error'
                })
            }

            if(status === 422) {
                if (e.request.responseType === "blob") {
                    return this.$blobErrModal(e)
                }
                const valid = new ValidationErrorService(e)
                this.$notify({
                    title: valid.errors.message[0],
                    type: 'error'
                })
            }

            if(status === 429) {
                this.tooManyError(e)
            }

            if(status === 403) {
                this.forbidden(e)
            }
        },

        serverError(message='技術的な問題が発生しています。\n処理を中断しました。', call = value => {}) {
            const h = this.$createElement
            const messageVNode = h('b-alert', {
                class: ['m-0'],
                props: {
                    variant: 'danger',
                    show: true,
                }}, [message]
            )

            this.msgBoxOk(messageVNode, call())
        },

        tooManyError(e) {
            const h = this.$createElement
            const messageVNode = h('b-alert', {
                class: ['m-0'],
                props: {
                    variant: 'warning',
                    show: true
                }
            }, ['アクセス回数を超えました。\n時間を置き再度アクセスして下さい。'])

            this.msgBoxOk(messageVNode)
        },

        forbidden(e) {
            const h = this.$createElement
            const messageVNode = h('b-alert', {
                class: ['m-0'],
                props: {
                    variant: 'warning',
                    show: true
                }
            }, [e.response.data.message])

            this.msgBoxOk(messageVNode)
        },

        getStatus(e) {
            if(e.response) {
                const { status } = e.response
                return status
            }
            return null
        },

        msgBoxOk(messageVNode, options = {}, call = value => {}) {
            const defaultOption = {
                bodyClass: "p-0",
                size: "lg",
                hideFooter: true,
                footerClass: 'd-none'
            }

            const option = Object.assign(defaultOption, options)

            this.$bvModal.msgBoxOk([messageVNode], option)
                .then(value => {
                    call(value)
                })
                .catch(err => {
                    // An error occurred
                })
        },


        async $blobErrModal(e) {
            const text = await fileReader(e.response.data);
            const data = JSON.parse(text)

            const h = this.$createElement

            const element = linq.from(data.errors)
                .selectMany(x => linq.from(x.value).flatten())
                .select(x => h('li', {}, [x]))
                .toArray()


            const messageVNode = h('b-alert', {
                class: ['m-0'],
                props: {
                    variant: 'warning',
                    show: true
                }
            }, [h('ul', {class: ['m-0']}, element)])

            this.msgBoxOk(messageVNode)
        }

    }



}



// WEBPACK FOOTER //
// ./resources/assets/js/utility/modalUtility.js